{
  "app.title": "به {{app}} خوش آمدید",
  "global.about": "درباره",
  "global.professionals": "پیشینه بالینی",
  "global.therapist_treatments": "روش‌های درمانی",
  "global.filters": "فیلترها",
  "global.back": "بازگشت",
  "global.me": "خودم",
  "global.others": "برای خانواده یا دوستان",
  "global.addNewMember": "افزودن عضو جدید",
  "global.enter.dashboard": "ورود به داشبورد",
  "global.return.manpage": "بازگشت به صفحه اصلی",
  "global.loading": "در حال بارگذاری...",
  "global.retry": "تلاش مجدد",
  "global.logout": "خروج از حساب",
  "nav.home": "خانه",
  "nav.page2": "صفحه ۲",
  "form.error.email": "ایمیل نادرست است",
  "form.error.pattern": "الگو نادرست است",
  "form.error.password.match": "پسسوورد سازگار نیست ",
  "form.error.min": "حداقل کاراکتر باید",
  "form.error.max": "حداکثر کاراکتر باید",
  "form.error.max.reach": "حداکثر کاراکتر پر شد",
  "form.select.emptyMessage": "موردی یافت نشد",
  "nav.selectDoctor": "یافتن پزشک",
  "profile.myProfile": "پروفایل من",
  "profile.signOut": "خروج",
  "shared.button.save": "ذخیره",
  "shared.button.cancel": "انصراف",
  "signin.platformName": "ویرا",
  "signin.title.base": "ورود یا ثبت‌نام",
  "signin.title": "ورود",
  "signin.tabs.email": "ایمیل",
  "signin.tabs.phone": "شماره موبایل",
  "signin.label.email": "آدرس ایمیل",
  "signin.label.phone": "شماره موبایل",
  "signin.submit": "ادامه",
  "signin.subtitle": "با ما در مسیر سلامت روان همراه شوید.",
  "signin.guestPrompt": "نیاز به رزرو سریع دارید؟",
  "signin.guestAction": "رزرو نوبت بدون ورود",
  "signin.otp.title": "کد ۶ رقمی را وارد کنید",
  "signin.otp.changeEmail": "تغییر ایمیل",
  "signin.email.massage": "آدرس ایمیل معتبر خود را وارد کنید",
  "signin.phone.massage": "شماره موبایل شما (مثلاً ۹۱۲۱۲۳۴۵۶۷)",
  "signin.otp.changePhone": "تغییر شماره موبایل",
  "signin.validation.required": "این فیلد الزامی است.",
  "signin.validation.email": "آدرس ایمیل معتبر وارد کنید.",
  "signin.validation.phone": "شماره موبایل معتبر وارد کنید.",
  "signin.validation.invalid": "مقدار نامعتبر است.",
  "signin.validation.invalidIdentifier": "ایمیل یا شماره موبایل ثبت نشده است.",
  "signin.validation.invalidOtp": "کد تأیید نامعتبر است.",
  "signin.validation.internationalEmailRequired": "مراجعین ساکن خارج از ایران باید با ایمیل ثبت‌نام کنند.",
  "signin.validation.tooManyRequests": "تلاش‌های زیادی انجام شده است. لطفاً بعداً تلاش کنید.",
  "signin.noAccount": "حساب کاربری ندارید؟",
  "signin.createAccount": "ایجاد حساب کاربری",
  "signup.title": "ایجاد حساب کاربری",
  "signup.tabs.email": "ایمیل",
  "signup.tabs.phone": "شماره موبایل",
  "signup.label.firstName": "نام",
  "signup.label.lastName": "نام خانوادگی",
  "signup.label.email": "آدرس ایمیل",
  "signup.label.phone": "شماره موبایل",
  "signup.placeholder.firstName": "علی",
  "signup.placeholder.lastName": "احمدی",
  "signup.submit": "ایجاد حساب",
  "signup.subtitle": "ثبت‌نام با رمز یکبار مصرف",
  "signup.signinPrompt": "قبلاً حساب کاربری دارید؟",
  "signup.signinAction": "ورود به حساب",
  "signup.otp.title": "کد ۶ رقمی را وارد کنید",
  "signup.validation.required": "این فیلد الزامی است.",
  "signup.validation.email": "آدرس ایمیل معتبر وارد کنید.",
  "signup.validation.phone": "شماره موبایل معتبر وارد کنید.",
  "signup.validation.invalid": "مقدار نامعتبر است.",
  "signup.validation.minLength": "حداقل ۲ حرف الزامی است.",
  "otp.timer": "زمان باقی‌مانده",
  "otp.submit": "تأیید کد",
  "otp.notReceived": "کد را دریافت نکردید؟",
  "otp.resend": "ارسال مجدد کد",
  "nameForm.title": "بیایید شما را بشناسیم",
  "nameForm.enterName": "اطلاعات فردی",
  "nameForm.specifications": "مشخصات",
  "nameForm.step.identity": "هویت",
  "nameForm.step.demographics": "اطلاعات فردی",
  "nameForm.step.context": "تکمیل پروفایل",
  "nameForm.stepProgress": "مرحله {{current}} از {{total}}",
  "nameForm.previous": "قبلی",
  "nameForm.next": "ادامه",
  "nameForm.label.firstName": "نام",
  "nameForm.label.lastName": "نام خانوادگی",
  "nameForm.label.country": "کشور",
  "nameForm.label.age": "سن",
  "nameForm.label.birthdate": "تاریخ تولد",
  "nameForm.label.gender": "جنسیت",
  "nameForm.label.maritalStatus": "وضعیت تاهل",
  "nameForm.label.hasChildren": "فرزند",
  "nameForm.label.mobile": "شماره موبایل",
  "nameForm.label.email": "ایمیل",
  "nameForm.label.nationalID": "کد ملی",
  "nameForm.gender.male": "مرد",
  "nameForm.gender.female": "زن",
  "nameForm.gender.other": "سایر",
  "nameForm.marital.single": "مجرد",
  "nameForm.marital.married": "متاهل",
  "nameForm.marital.divorced": "مطلقه",
  "nameForm.children.no": "خیر",
  "nameForm.children.yes": "بله",
  "nameForm.placeholder.firstName": "علی",
  "nameForm.placeholder.lastName": "احمدی",
  "nameForm.submit": "تکمیل ",
  "nameForm.validation.required": "این فیلد الزامی است.",
  "nameForm.validation.minLength": "حداقل ۲ حرف الزامی است.",
  "nameForm.validation.termsRequired": "باید قوانین و مقررات را بپذیرید.",
  "nameForm.termsPrefix": " من موافقم با ",
  "nameForm.termsLink": " سیاست حفظ حریم خصوصی ",
  "nameForm.termsTitle": "قوانین و مقررات",
  "nameForm.termsWelcome": "به پورتال بیمار چمن خوش آمدید",
  "nameForm.termsIntro": "با استفاده از خدمات ما، شما این قوانین را می‌پذیرید. لطفاً با دقت مطالعه کنید.",
  "nameForm.termsAcceptanceTitle": "۱. پذیرش قوانین",
  "nameForm.termsAcceptance": "با دسترسی و استفاده از خدمات کلینیک چمن، شما شرایط و مقررات این توافقنامه را می‌پذیرید.",
  "nameForm.termsUseTitle": "۲. استفاده از خدمات",
  "nameForm.termsUse": "خدمات ما برای اهداف بهداشتی و درمانی در نظر گرفته شده است. شما موظف هستید از پلتفرم به طور مسئولانه استفاده کنید و اطلاعات دقیق ارائه دهید.",
  "nameForm.termsPrivacyTitle": "۳. حریم خصوصی و حفاظت از داده‌ها",
  "nameForm.termsPrivacy": "ما متعهد به محافظت از اطلاعات شخصی و پزشکی شما هستیم. داده‌های شما طبق قوانین حریم خصوصی و سیاست‌های ما مدیریت خواهند شد.",
  "nameForm.termsAccountTitle": "۴. مسئولیت‌های حساب کاربری",
  "nameForm.termsAccount": "شما مسئول حفظ محرمانگی اطلاعات حساب کاربری خود و تمام فعالیت‌های انجام شده از طریق حساب خود هستید.",
  "nameForm.termsModificationTitle": "۵. تغییرات قوانین",
  "nameForm.termsModification": "ما حق تغییر این قوانین را در هر زمان محفوظ می‌داریم. ادامه استفاده از خدمات پس از تغییرات به معنای پذیرش قوانین جدید است.",
  "nameForm.termsContactTitle": "۶. اطلاعات تماس",
  "nameForm.termsContact": "در صورت داشتن سوال درباره این قوانین و مقررات، لطفاً با تیم پشتیبانی ما تماس بگیرید.",
  "nameForm.termsClose": "بستن",
  "toast.otpSent": "کد تأیید به {{method}} شما ارسال شد",
  "toast.otpFailed": "ارسال کد تأیید ناموفق بود. لطفاً دوباره تلاش کنید.",
  "toast.otpVerified": "کد با موفقیت تأیید شد",
  "toast.otpInvalid": "کد تأیید نامعتبر است. لطفاً دوباره تلاش کنید.",
  "toast.invalidOtp": "کد تأیید نامعتبر است. لطفاً دوباره تلاش کنید.",
  "toast.loginSuccess": "ورود با موفقیت انجام شد",
  "toast.completeProfile": "لطفاً پروفایل خود را برای ادامه تکمیل کنید",
  "toast.completeRegistration": "لطفاً ثبت‌نام خود را تکمیل کنید",
  "toast.registrationComplete": "ثبت‌نام با موفقیت تکمیل شد",
  "toast.registrationFailed": "ثبت‌نام ناموفق بود. لطفاً دوباره تلاش کنید.",
  "toast.signupComplete": "حساب کاربری با موفقیت ایجاد شد",
  "toast.signinSuccess": "ورود با موفقیت انجام شد",
  "errors.title": "خطا",
  "errors.unknown": "خطای غیرمنتظره‌ای رخ داد. لطفاً دوباره تلاش کنید.",
  "errors.networkError": "اتصال به سرور برقرار نشد. لطفاً اتصال اینترنت خود را بررسی کنید.",
  "errors.connectionTitle": "خطای اتصال",
  "errors.badRequest": "درخواست نامعتبر است. لطفاً ورودی خود را بررسی کنید.",
  "errors.unauthorized": "نشست شما منقضی شده است. لطفاً دوباره وارد شوید.",
  "errors.authTitle": "احراز هویت مورد نیاز",
  "errors.forbidden": "شما دسترسی به این منبع را ندارید.",
  "errors.accessTitle": "دسترسی رد شد",
  "errors.notFound": "منبع درخواستی یافت نشد.",
  "errors.validationError": "لطفاً خطاهای فرم را تصحیح کنید.",
  "errors.tooManyRequests": "درخواست‌های زیادی ارسال شده است. لطفاً کمی صبر کنید.",
  "errors.serverError": "خطای سرور رخ داد. تیم ما مطلع شده است.",
  "errors.serverTitle": "خطای سرور",
  "errors.serviceUnavailable": "سرویس موقتاً در دسترس نیست. لطفاً بعداً تلاش کنید.",
  "selectDoctor.results": "نتیجه",
  "selectDoctor.loading": "در حال بارگذاری درمانگران...",
  "singleDoctor.loading": "در حال بارگذاری درمانگر...",
  "selectDoctor.noResults": "درمانگری یافت نشد",
  "selectDoctor.doctorsFound": "درمانگر یافت شد",
  "selectDoctor.loadAgain": "بارگذاری دوباره",
  "filters.reset": "پاک کردن همه",
  "filters.apply": "اعمال فیلترها",
  "filters.showResults": "نمایش نتایج",
  "filters.specializations": "تخصص‌ها",
  "filters.professionals": "درمانگران",
  "filters.therapy_types": "انواع درمان",
  "filters.therapist_treatments": "درمان‌های روان‌شناسی",
  "filters.genders": "جنسیت",
  "filters.disorders": "اختلالات",
  "filters.bipolar": "اختلال دوقطبی",
  "filters.depression": "افسردگی",
  "filters.dissociative": "اختلالات تجزیه‌ای",
  "filters.obsessive": "اختلال وسواس فکری-عملی",
  "filters.eating": "اختلالات خوردن",
  "filters.gender": "ناهنجاری جنسیتی",
  "filters.personality": "اختلال شخصیت",
  "filters.somatic": "اختلال علائم جسمانی",
  "filters.trauma": "تروما",
  "filters.addiction": "اعتیاد",
  "filters.languages": "زبان‌ها",
  "filters.dutch": "هلندی",
  "filters.english": "انگلیسی",
  "filters.turkish": "ترکی",
  "filters.moroccan": "عربی مراکشی",
  "filters.polish": "لهستانی",
  "filters.german": "آلمانی",
  "filters.french": "فرانسوی",
  "filters.spanish": "اسپانیایی",
  "filters.chinese": "چینی/ماندارین",
  "filters.farsi": "فارسی",
  "filters.arabic": "عربی",
  "filters.contact": "اطلاعات تماس",
  "filters.appointmentCost": "هزینه هر جلسه",
  "search.instruction": "برای یافتن نتایج مرتبط جستجو یا فیلتر کنید. نتایج فعلی بر اساس جدیدترین مرتب شده‌اند.",
  "search.waitTime": "زمان انتظار",
  "search.distance": "فاصله",
  "search.showMap": "نمایش نقشه",
  "sort.relevance": "مرتبط‌ترین",
  "sort.rating": "امتیاز",
  "sort.availability": "نوبت‌های خالی",
  "sort.experience": "تجربه",
  "sort.nameAsc": "نام (الف-ی)",
  "sort.nameDesc": "نام (ی-الف)",
  "doctorCard.weeks": "هفته",
  "doctorCard.defaultRole": "ارائه‌دهنده خدمات بهداشتی",
  "doctor-appointment.relate": "نسبت",
  "doctor-appointment.relation.spouse": "شریک عاطفی",
  "doctor-appointment.completeData": "لطفاً اطلاعات فرم را تکمیل کنید.",
  "relations.spouse": "شریک عاطفی",
  "relations.child": "فرزند",
  "doctor-appointment.relation.child": "فرزند",
  "doctor-appointment.add.new": "افزودن عضو جدید",
  "doctor-appointment.peyment.failed": "پرداخت ناموفق",
  "doctor-appointment.peyment.failed.description": "لطفاً بعداً دوباره تلاش کنید.",
  "doctor-appointment.confirm": "نوبت شما تأیید شد",
  "doctor-appointment.confirm.description": "نوبت با موفقیت رزرو شد و پیام تأیید برایتان ارسال شد.",
  "doctor-appointment.cancel": "نوبت شما لغو شد",
  "doctor-appointment.cancel.description": "نوبت با موفقیت لغو شد و پیام لغو برایتان ارسال شد.",
  "doctor-appointment.next.session": "جلسه بعدی شما",
  "doctor-appointment.reminder": "پیش از جلسه، یادآوری برای شما ارسال خواهد شد.",
  "doctor-appointment.confirm.email": "ایمیل تأییدیه به آدرس ایمیل ثبت‌شده شما ارسال شد.",
  "doctor-appointment.title": "رزرو نوبت",
  "doctor-appointment.select-date": "تاریخ و زمان را انتخاب کنید",
  "doctor-appointment.fee-per-session": "هزینه هر جلسه",
  "doctor-appointment.appointment-type": "نوع نوبت",
  "doctor-appointment.appointment-type.video-call": "تماس تصویری",
  "doctor-appointment.appointment-type.in-person": "حضوری",
  "doctor-appointment.appointment-type.online-meeting": "جلسه آنلاین",
  "doctor-appointment.appointment-type.online": "آنلاین",
  "doctor-appointment.appointment-type.visit-in-site": "جلسه حضوری در کلینیک",
  "doctor-appointment.appointment-type.onsite": "حضوری",
  "doctor-appointment.session-type": "نوع جلسه",
  "doctor-appointment.select-time": "ساعت",
  "doctor-appointment.select-date-datepicker": "تاریخ",
  "doctor-appointment.select-service": "خدمت",
  "doctor-appointment.select-service-placeholder": "یک خدمت را انتخاب کنید",
  "doctor-appointment.services-load-failed": "دریافت خدمات در دسترس انجام نشد. لطفاً دوباره تلاش کنید.",
  "doctor-appointment.locked-schedule-title": "جلسه رزرو شده شما",
  "doctor-appointment.payment-deadline": "مهلت پرداخت تا",
  "doctor-appointment.continue": "ادامه و انتخاب درمانگر",
  "doctor-appointment.continue-to-pay": "ادامه به پرداخت",
  "doctor-appointment.owner": "تشکیل پرونده جدید",
  "doctor-appointment.reservation-info": "شما می‌توانید برای خودتان، خانواده یا دوستان نوبت رزرو کنید. اطلاعات همراهان شما به‌صورت امن ذخیره می‌شود.",
  "doctor-appointment.owner-information": "برای تشکیل پرونده جدید، مراجعه یا مراجعان را انتخاب نمایید",
  "doctor-appointment.participant-type.myself": "خودم",
  "doctor-appointment.participant-type.relation": "زوج",
  "doctor-appointment.participant-type.child": "فرزندم",
  "doctor-appointment.select-participants-first": "لطفاً ابتدا افراد را انتخاب کنید.",
  "doctor-appointment.participants-empty-error": "لطفاً حداقل یک نفر به‌جز خودتان انتخاب کنید.",
  "doctor-appointment.submit": "ثبت",
  "doctor-info.title": "اطلاعات درمانگر",
  "doctor-info.description": "با درمانگر خود آشنا شوید",
  "select-doctor.title": "انتخاب درمانگر",
  "select-doctor.description": "درمانگر مورد نظر را انتخاب نمایید",
  "select-doctor.filters.searchInput": "جستجو بر اساس نام، ایمیل یا تلفن",
  "timepicker.available": "در دسترس",
  "timepicker.selected": "انتخاب شده",
  "timepicker.inactive": "غیر فعال",
  "timepicker.no-available-times": "نوبتی برای روز جاری وجود ندارد",
  "datepicker.selectDate": "تاریخ را انتخاب کنید",
  "patient.reservedDoctor": "رزرو نوبت",
  "sidebar.collapse": "بستن",
  "sidebar.back": "بازگشت",
  "patient.sidebar.brandName": "چمان",
  "patient.sidebar.home": "خانه",
  "patient.sidebar.meetings": " تاریخچه جلسات",
  "patient.sidebar.transactions": "تراکنش‌ها",
  "patient.sidebar.wallet": "کیف پول",
  "patient.sidebar.treatment": "طرح درمان",
  "patient.sidebar.contactUs": "تماس با ما",
  "patient.contactUs.title": "تماس با ما",
  "patient.contactUs.message": "می‌توانید از طریق تلفن یا واتساپ با پشتیبانی در ارتباط باشید.",
  "patient.contactUs.call": "تماس تلفنی",
  "patient.contactUs.whatsapp": "واتساپ",
  "payment-method.payment": "بررسی و پرداخت",
  "payment-method.appointment-details": "جزئیات رزرو نوبت",
  "payment-method.date": "تاریخ",
  "payment-method.appointment-time-start": "ساعت شروع",
  "payment-method.appointment-time-end": "ساعت پایان",
  "payment-method.appointment-type": "نوع جلسه",
  "payment-method.visit-cost": "هزینه جلسه",
  "payment-method.sum": "مجموع هزینه قابل پرداخت",
  "payment-method.confirm-and-pay": "تأیید و پرداخت",
  "payment-method.fast-pay": "پرداخت امن",
  "payment-method.fast-confirm": "تأیید فوری",
  "payment-method.free-cancellation": "لغو رایگان",
  "payment-method.payment-methods": "درگاه‌های پرداخت",
  "payment-method.payment-info-notfound": "اطلاعات پرداخت یافت نشد",
  "payment-method.payment-info-is-not-complete": "اطلاعات پرداخت کامل نیست",
  "payment-method.select-payment-method": "لطفاً روش پرداخت را انتخاب کنید.",
  "payment-method.navigation-failed": "انتقال به صفحه انتخاب بیمار انجام نشد. لطفاً دوباره تلاش کنید.",
  "payment-method.ledger.title": "خلاصه پرداخت",
  "payment-method.ledger.base-fee": "هزینه جلسه",
  "payment-method.ledger.base-fee-batch": "هزینه ({{count}} جلسه)",
  "payment-method.ledger.discount": "تخفیف",
  "payment-method.wallet": "کیف پول",
  "payment-method.ledger.wallet-balance": "موجودی کیف پول",
  "payment-method.ledger.use-wallet": "استفاده از موجودی کیف پول",
  "payment-method.ledger.no-wallet-balance": "موجودی کیف پول ندارید",
  "payment-method.ledger.net-payable": "قابل پرداخت آنلاین",
  "payment-method.ledger.wallet-covered-success": "از موجودی کیف پول شما پرداخت شد و نوبت شما تأیید شد.",
  "payment-method.ledger.wallet-covers-full": "موجودی کیف پول شما کل هزینه این نوبت را پوشش می‌دهد — نیازی به انتخاب درگاه نیست. فقط «پرداخت» را بزنید.",
  "payment-method.methods-load-failed": "بارگذاری روش‌های پرداخت انجام نشد. لطفاً دوباره تلاش کنید.",
  "payment-method.ledger.no-charge": "این نوبت هزینه‌ای برای پرداخت ندارد — نیازی به انتخاب درگاه نیست. برای تأیید، «پرداخت» را بزنید.",
  "payment-method.ledger.no-charge-success": "نوبت شما تأیید شد.",
  "payment-method.hold-note": "با زدن «پرداخت»، این نوبت {{minutes}} دقیقه برای شما نگه داشته می‌شود؛ اگر پرداخت در این مدت کامل نشود، نوبت آزاد می‌شود.",
  "payment-method.hold-note-batch": "با زدن «پرداخت»، این نوبت‌ها {{minutes}} دقیقه برای شما نگه داشته می‌شوند؛ اگر پرداخت در این مدت کامل نشود، نوبت‌ها آزاد می‌شوند.",
  "payment-method.ledger.wallet-unusable": "کیف پول شما فعلاً برای پرداخت‌های {{currency}} قابل استفاده نیست.",
  "payment-method.held-notice": "بخشی از موجودی شما ({{amount}}) به ارز دیگری است و تا رسیدگی کلینیک قابل استفاده نیست. کلینیک با شما تماس می‌گیرد.",
  "payment-method.no-gateway": "این کلینیک امکان دریافت آنلاین پرداخت شما را ندارد. لطفاً با کلینیک تماس بگیرید.",
  "payment-method.residency-unknown": "روش پرداخت شما مشخص نیست. لطفاً با کلینیک تماس بگیرید.",
  "payment-method.currency-adjective.IRR": "ریالی",
  "payment-method.currency-adjective.USD": "دلاری",
  "payment-method.currency-adjective.EUR": "یورویی",
  "payment-method.currency-name.IRR": "ریال",
  "payment-method.currency-name.USD": "دلار",
  "payment-method.currency-name.EUR": "یورو",
  "payment-method.processing-title": "پرداخت شما در حال پردازش است",
  "payment-method.processing-description": "نوبت شما پس از تأیید پرداخت توسط کلینیک قطعی می‌شود. نیازی به پرداخت دوباره نیست.",
  "expiry-banner.remaining": "زمان باقی‌مانده برای تکمیل پرداخت",
  "expiry-banner.expired": "زمان رزرو شما به پایان رسید و این نوبت آزاد شد.",
  "expiry-banner.expired-blocked": "این رزرو منقضی شده است. برای ادامه، لطفاً زمان جدیدی انتخاب کنید.",
  "payment-link.not-found-title": "لینک پرداخت یافت نشد",
  "payment-link.expired-title": "لینک پرداخت منقضی شده است",
  "payment-link.contact-clinic": "لطفاً برای دریافت لینک پرداخت جدید با کلینیک خود تماس بگیرید.",
  "payment-link.no-gateways-available": "این کلینیک امکان دریافت آنلاین پرداخت شما را ندارد. لطفاً با کلینیک تماس بگیرید.",
  "payment-link.time-remaining": "زمان باقی‌مانده: {{hours}} ساعت و {{minutes}} دقیقه",
  "payment-link.expired-short": "این لینک منقضی شده است",
  "payment-link.select-gateway": "لطفاً یک درگاه پرداخت انتخاب کنید.",
  "payment-link.result-load-failed": "امکان دریافت نتیجه پرداخت وجود ندارد",
  "payment-link.success-title": "نوبت شما تأیید شد",
  "payment-link.success-description": "نوبت با موفقیت رزرو شد و پیام تأیید برایتان ارسال شد.",
  "payment-link.failure-title": "پرداخت ناموفق بود",
  "payment-link.doctor": "درمانگر",
  "payment-link.amount-paid": "مجموع هزینه پرداخت شده",
  "payment-link.reference": "کد پیگیری پرداخت",
  "payment-link.try-again": "تلاش مجدد",
  "payment-link.failure-body": "پرداخت شما انجام نشد. اگر مبلغی از حساب شما کسر شده باشد، ظرف ۷۲ ساعت به حساب بانکی شما بازگردانده می‌شود. اگر تا آن زمان بازگردانده نشد، لطفاً برای پیگیری با کلینیک تماس بگیرید.",
  "payment-link.pending-title": "پرداخت در حال پردازش است",
  "payment-link.pending-body": "هنوز در حال تأیید پرداخت شما با بانک هستیم. این صفحه به‌صورت خودکار به‌روزرسانی می‌شود.",
  "payment-link.pending-unconfirmed": "پرداخت شما هنوز تأیید نشده است. لطفاً دوباره پرداخت نکنید. اگر مبلغی کسر شده و پرداخت تأیید نشود، ظرف ۷۲ ساعت به حساب بانکی شما بازگردانده می‌شود. اگر تا آن زمان بازگردانده نشد، لطفاً برای پیگیری با کلینیک تماس بگیرید.",
  "payment-link.check-again": "بررسی مجدد",
  "payment-link.refund-due-title": "پرداخت دریافت شد، اما نوبت ثبت نشد",
  "payment-link.refund-due-body": "پرداخت شما دریافت شد، اما این نوبت پیش‌تر منقضی یا لغو شده بود و امکان ثبت آن وجود نداشت. کلینیک از این پرداخت مطلع شده است و مبلغ را به شما بازمی‌گرداند.",
  "payment-link.contact-clinic-questions": "در صورت هرگونه سؤال، لطفاً با کلینیک تماس بگیرید.",
  "payment-link.gateway-failed-title": "ارتباط با درگاه پرداخت برقرار نشد",
  "payment-link.gateway-failed": "مبلغی از حساب شما کسر نشد و لینک پرداخت همچنان معتبر است. لطفاً یک روش پرداخت انتخاب کنید و دوباره تلاش نمایید.",
  "payment-link.reason-link-expired": "این لینک پرداخت دیگر معتبر نیست.",
  "payment-link.reason-appointment-expired": "مهلت نگهداری این نوبت به پایان رسیده است.",
  "payment-link.reason-appointment-cancelled": "این نوبت لغو شده است.",
  "payment-link.reason-already-paid": "هزینه این نوبت قبلاً پرداخت شده است.",
  "payment-history.status": "وضعیت",
  "payment-history.amount": "مبلغ",
  "payment-history.expires_at": "تاریخ انقضا",
  "payment-history.created_at": "تاریخ تراکنش",
  "payment-history.transaction-history": "تاریخچه تراکنش",
  "payment-history.my-wallet": "کیف پول من",
  "payment-history.balance": "موجودی",
  "payment-history.money-return": "استرداد وجه",
  "payment-history.irtoman": "تومان",
  "payment-history.transaction_id": "کد رهگیری",
  "payment-history.description": "توضیحات",
  "payment-history.withdraw-funds": "برداشت وجه",
  "payment-history.amount-min-error": "حداقل مبلغ ۱,۰۰۰ {{currency}} است",
  "payment-history.card-number": "شماره کارت",
  "payment-history.card-invalid-error": "شماره کارت باید دقیقاً ۱۶ رقم باشد.",
  "payment-history.account-holder": "نام صاحب حساب",
  "payment-history.wallet.loading-balance": "در حال بارگذاری موجودی ...",
  "global.loadMore": "بارگذاری بیشتر",
  "global.cancel": "انصراف",
  "global.submit": "ثبت",
  "global.required": "این فیلد الزامی است.",
  "global.success": "موفقیت آمیز",
  "currency.IRR": "ریال",
  "currency.USD": "دلار",
  "currency.EUR": "یورو",
  "patient-home.reserve-new-appointment": "تشکیل پرونده",
  "patient-home.reserve-appointment-for": "رزرو نوبت",
  "patient-home.home": "خانه",
  "patient-home.1th": "اول",
  "patient-home.2th": "دوم",
  "patient-home.3th": "سوم",
  "patient-home.4th": "چهارم",
  "patient-home.5th": "پنجم",
  "patient-home.6th": "ششم",
  "patient-home.7th": "هفتم",
  "patient-home.8th": "هشتم",
  "patient-home.9th": "نهم",
  "patient-home.10th": "دهم",
  "patient-home.11th": "یازدهم",
  "patient-home.12th": "دوازدهم",
  "patient-home.13th": "سیزدهم",
  "patient-home.14th": "چهاردهم",
  "patient-home.15th": "پانزدهم",
  "patient-home.16th": "شانزدهم",
  "patient-home.17th": "هفدهم",
  "patient-home.18th": "هجدهم",
  "patient-home.19th": "نوزدهم",
  "patient-home.20th": "بیستم",
  "patient-home.session": "جلسه",
  "patient-home.support-request-title": "ارسال درخواست پشتیبانی",
  "patient-home.support-request-send-to-whatsapp": "ارسال با واتساپ",
  "patient-home.support-request-send-to-bale": "ارسال با بله",
  "patient-home.support-request-send-to-sms": "ارسال با پیامک",
  "patient-home.support-request-textarea-label": "توضیحات",
  "patient-home.support-request-cancel": "لغو",
  "patient-home.support-request-appointment-id": "شناسه نوبت",
  "patient-home.support-request-sms-toast-title": "توجه",
  "patient-home.support-request-sms-toast": "پیام شما در حافظه موقت‌تان کپی شد. لطفاً به این شماره ارسال کنید: {{phone}}.",
  "active-session.time": "ساعت",
  "active-session.date": "تاریخ",
  "active-session.type": "نوع جلسه",
  "active-session.visitor-name": "نام مراجع",
  "active-session.clinic-name": "کلینیک",
  "active-session.clinic-label": "کلینیک {{name}}",
  "active-session.description": "توضیحات",
  "active-session.appointment": "حضوری",
  "active-session.online": "آنلاین",
  "doctor-appointment.enter-meeting": "ورود به جلسه",
  "doctor-appointment.support": "پشتیبانی",
  "doctor-appointment.cancel-appointment": "لغو نوبت",
  "doctor-appointment.proceed-to-payment": "ادامه پرداخت",
  "doctor-appointment.change-time": "تغییر زمان",
  "error.general-error": "خطا در دریافت اطلاعات",
  "doctor-appointment.cancel-appointment-description": "مبلغ پرداخت‌شده (در کمتر از ۲۴ ساعت) به اعتبار شما بازمی‌گردد.",
  "doctor-appointment.cancel-appointment-description-pending-payment": "این نوبت هنوز پرداخت نشده است. با لغو آن، این زمان آزاد خواهد شد.",
  "doctor-appointment.cancel-appointment-refound-amount": "مبلغ بازگشتی",
  "doctor-appointment.cancecl": "انصراف",
  "doctor-appointment.submit-and-cancel": "تأیید و لغو",
  "profile-settings.title": "تنظیمات برنامه",
  "profile-settings.language": "زبان",
  "profile-settings.select-language": "یک زبان انتخاب کنید",
  "profile-settings.timezone": "منطقه زمانی",
  "profile-settings.select-timezone": "جستجو و انتخاب منطقه زمانی",
  "profile-settings.language.fa": "فارسی",
  "profile-settings.language.en": "انگلیسی",
  "profile-settings.language.de": "آلمانی",
  "profile-settings.language.du": "هلندی",
  "appointment-card.status.pending": "در انتظار رزرو",
  "appointment-card.status.pending_payment": "در انتظار پرداخت",
  "appointment-card.status.scheduled": "تأییدشده",
  "appointment-card.status.completed": "برگزارشده",
  "appointment-card.pending-description": "این جلسه هنوز رزرو نشده است. برای رزرو، یک زمان انتخاب کنید.",
  "appointment-card.progress": "{{done}} از {{total}} جلسه برگزار شده",
  "appointment-card.sessions-strip": "پیشرفت جلسات: {{done}} از {{total}} برگزار شده",
  "appointment-card.next": "جلسه بعدی",
  "appointment-card.and": "و",
  "appointment-card.selected": "انتخاب‌شده",
  "appointment-card.not-booked": "هنوز رزرو نشده",
  "appointment-card.all-done": "همه جلسات این طرح درمان برگزار شده است.",
  "appointment-card.pay": "پرداخت {{amount}}",
  "appointment-card.book": "رزرو این جلسه",
  "appointment-card.show-sessions": "همه جلسات و گزینه‌ها",
  "appointment-card.hide-sessions": "بستن فهرست جلسات",
  "appointment-card.actions-for": "این گزینه‌ها مربوط به {{session}} است.",
  "appointment-card.locked-hint": "تغییر یا لغو این جلسه از اینجا دیگر ممکن نیست. در صورت نیاز با پشتیبانی تماس بگیرید.",
  "patient-home.empty-title": "اولین پرونده خود را تشکیل دهید",
  "patient-home.empty-body": "پس از رزرو، جلسات و پرداخت‌های شما اینجا نمایش داده می‌شود.",
  "patient-home.load-failed": "دریافت جلسات شما انجام نشد. لطفاً دوباره تلاش کنید.",
  "doctor-appointment.next-available-title": "برای این روز زمانی موجود نیست",
  "doctor-appointment.next-available-description": "نزدیک‌ترین زمان قابل رزرو در ادامه آمده است.",
  "doctor-appointment.next-available-action": "رفتن به این زمان",
  "doctor-appointment.next-available-none": "در این ماه زمان قابل رزروی باقی نمانده است. لطفاً ماه دیگری را بررسی کنید.",
  "doctor-appointment.booking-deadline-notice": "امکان رزرو برای این روز بسته شده است: کلینیک پس از ساعت مقرر روزانه، رزرو برای روز بعد را نمی‌پذیرد.",
  "doctor-appointment.past-times-notice": "زمان‌های باقیمانده امروز سپری شده است.",
  "treatment-plan-batch.title": "رزرو جلسات طرح درمان",
  "treatment-plan-batch.instructions": "برای هر جلسه باقیمانده یک زمان انتخاب کنید. {{count}} جلسه هنوز زمان ندارد.",
  "treatment-plan-batch.service": "خدمت",
  "treatment-plan-batch.pick-slots": "زمان‌های در دسترس",
  "treatment-plan-batch.selected-slots": "زمان‌های انتخاب‌شده ({{count}})",
  "treatment-plan-batch.no-slots-selected": "پیش از ادامه، حداقل یک زمان انتخاب کنید.",
  "treatment-plan-batch.remove-slot": "حذف",
  "treatment-plan-batch.use-wallet-balance": "استفاده از موجودی کیف پول",
  "treatment-plan-batch.gateway": "روش پرداخت",
  "treatment-plan-batch.submit": "رزرو همه زمان‌های انتخاب‌شده",
  "treatment-plan-batch.pinned-group-uses-locked-slot": "این جلسه زمان هفتگی ثابت دارد و از همان نوبت رزروشده تأیید می‌شود.",
  "treatment-plan-batch.no-remaining-sessions": "همه جلسات این طرح درمان زمان دارند.",
  "treatment-plan-batch.session-limit-reached": "شما همه جلسات باقی‌مانده این طرح درمان را انتخاب کرده‌اید.",
  "treatment-plan-batch.session-count-load-failed": "دریافت جلسات باقی‌مانده انجام نشد. لطفاً دوباره تلاش کنید.",
  "booking.step.aria-label": "مراحل رزرو",
  "booking.step.who": "مراجع",
  "booking.step.expert": "درمانگر",
  "booking.step.time": "تاریخ و ساعت",
  "booking.step.pay": "پرداخت",
  "booking.step.progress": "مرحله {{current}} از {{total}}",
  "booking.step.state.done": "انجام شد",
  "booking.step.state.current": "مرحله فعلی",
  "booking.step.state.upcoming": "هنوز شروع نشده",
  "booking.summary.title": "رزرو شما",
  "booking.summary.show": "نمایش جزئیات رزرو",
  "booking.summary.hide": "بستن جزئیات رزرو",
  "booking.summary.who": "برای",
  "booking.summary.expert": "درمانگر",
  "booking.summary.service": "خدمت",
  "booking.summary.type": "نوع جلسه",
  "booking.summary.date": "تاریخ",
  "booking.summary.time": "ساعت",
  "booking.summary.fee": "هزینه جلسه",
  "booking.summary.not-chosen": "هنوز انتخاب نشده",
  "booking.summary.nothing-yet": "هنوز چیزی انتخاب نشده",
  "booking.owner.hint": "برای ادامه، مراجع را انتخاب کنید",
  "booking.owner.people": "افراد",
  "booking.expert-card.view-profile": "مشاهده پروفایل",
  "booking.expert-card.book": "رزرو نوبت",
  "booking.expert-card.next-available": "نخستین نوبت خالی",
  "booking.expert.about": "درباره درمانگر",
  "booking.time.hint": "برای ادامه، تاریخ و ساعت را انتخاب کنید",
  "booking.time.session-type": "نوع جلسه",
  "booking.pay.hint": "برای ادامه، روش پرداخت را انتخاب کنید.",
  "booking.pay.pay-amount": "پرداخت {{amount}}",
  "booking.confirm.details-title": "جزئیات جلسه",
  "booking.failed.retry-hint": "هزینه نوبت پرداخت نشد. اگر نوبت هنوز برای شما نگه داشته شده باشد، می‌توانید از داشبورد آن را پرداخت کنید.",
  "booking.batch.progress": "{{selected}} از {{total}} جلسه انتخاب شده"
}
